import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ContextUser } from '@/modules/common/types';

const CHAT_TITLES = ['withName1', 'withName2', 'help', 'question', 'ready'] as const;

export function useChatTitle(user?: ContextUser): string {
  const { t } = useTranslation();

  const chatTitle = useMemo(() => {
    if (!user) {
      return t('modules.mavue2.chat.titles.help');
    }

    const randomIndex = Math.floor(Math.random() * CHAT_TITLES.length);
    const key = CHAT_TITLES[randomIndex];

    return t(`modules.mavue2.chat.titles.${key}`, {
      firstName: user.firstName || '',
    });
  }, [t, user]);

  return chatTitle;
}
